import React, { useState, useEffect } from 'react';
import './Vouchers.css';
import '../cart/Carro.css';
import { usePermissions } from '../../../../Hooks/usePermissions';
import {
  SHOPPING_CART_PED,
  SHOPPING_CART_PRV,
} from '../../../../helpers/features';

export const Vouchers = () => {
  const [codigoComprobante, setCodigoComprobante] = useState(() => {
    const savedValue = localStorage.getItem('tilde');
    return savedValue ? Number(savedValue) : 1;
  });

  const { enablePedido, enablePresupuesto } = usePermissions();
  const pedido = enablePedido(SHOPPING_CART_PED);
  const presupuesto = enablePresupuesto(SHOPPING_CART_PRV);

  const handleCheckboxChange = (event) => {
    const newValue = Number(event.target.value);
    setCodigoComprobante(newValue);
    localStorage.setItem('tilde', newValue);
  };

  useEffect(() => {
    if (!pedido && presupuesto && codigoComprobante === 1) {
      setCodigoComprobante(2);
    }
    if (pedido && !presupuesto && codigoComprobante === 2) {
      setCodigoComprobante(1);
    }
  }, [pedido, presupuesto, codigoComprobante]);

  useEffect(() => {
    localStorage.setItem('tilde', codigoComprobante);
  }, [codigoComprobante]);

  if (!pedido && !presupuesto) {
    return null;
  }

  return (
    <div className="CardComprobantes">
      {presupuesto && pedido && (
        <article
          className="cardTitleComprob"
          onClick={() => setCodigoComprobante(presupuesto ? 2 : 1)}
        >
          <header>
            <h2>Elegí el tipo de Comprobante</h2>
          </header>
        </article>
      )}
      {presupuesto && (
        <article
          className={`cardComprob textleft ${codigoComprobante === 2 ? 'active' : ''}`}
          onClick={() => setCodigoComprobante(2)}
        >
          <label>
            <input
              type="radio"
              name="comprobante"
              value="2"
              checked={codigoComprobante === 2}
              onChange={handleCheckboxChange}
            />
            <span>Presupuesto</span>
          </label>
        </article>
      )}

      {pedido && (
        <article
          className={`cardComprob textleft ${codigoComprobante === 1 ? 'active' : ''}`}
          onClick={() => setCodigoComprobante(1)}
        >
          <label>
            <input
              type="radio"
              name="comprobante"
              value="1"
              checked={codigoComprobante === 1}
              onChange={handleCheckboxChange}
            />
            Pedido
          </label>
        </article>
      )}
    </div>
  );
};
